import { useEffect, useRef, useState } from 'react';

import { second } from '@utils/milliseconds';
import { Timeout } from '@utils/types';

export function useMinimumDelay(flag: boolean, minDuration: number = second) {
  const [visible, setVisible] = useState(false);

  const startRef = useRef(0);
  const timerRef = useRef<Timeout>();

  useEffect(() => {
    if (flag) {
      clearTimeout(timerRef.current);
      startRef.current = Date.now();
      setVisible(true);
    } else {
      const elapsed = Date.now() - startRef.current;
      const delay = Math.max(minDuration - elapsed, 0);
      timerRef.current = setTimeout(() => setVisible(false), delay);
    }

    return () => clearTimeout(timerRef.current);
  }, [flag, minDuration]);

  return visible;
}
